import React, { useState } from 'react';
import { Shield, Loader2 } from 'lucide-react';
import { verifyTwoFactorSession } from '../utils/api';

export default function TwoFactorGate({ userEmail, onVerified, onLogout }) {
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    const c = code.replace(/\D/g, '').slice(0, 6);
    if (c.length !== 6) {
      setErr('Enter the 6-digit code from your authenticator app.');
      return;
    }
    setLoading(true);
    try {
      await verifyTwoFactorSession(c);
      onVerified();
    } catch (ex) {
      setErr(ex.message || 'Invalid code. Try again.');
    }
    setLoading(false);
  };

  return (
    <div className="login-screen twofa-gate">
      <div className="bg-mesh" />
      <div className="glass glass-elevated twofa-card anim-rise">
        <div className="twofa-icon-wrap">
          <Shield size={36} className="twofa-icon" />
        </div>
        <h1 className="twofa-title">Two-step verification</h1>
        <p className="twofa-sub">
          Signed in as <strong>{userEmail}</strong>. Enter the code from your authenticator app to continue.
        </p>
        <form onSubmit={submit} className="twofa-form">
          <input
            className="twofa-input"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="000000"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            autoFocus
          />
          {err && <div className="login-error twofa-err">{err}</div>}
          <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
            {loading ? (
              <>
                <Loader2 size={18} className="btn-spinner" /> Verifying…
              </>
            ) : (
              'Verify & continue'
            )}
          </button>
        </form>
        <button type="button" className="btn btn-sm twofa-logout" onClick={onLogout}>
          Use a different account
        </button>
      </div>
    </div>
  );
}
